<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <div class="presentation-page__body">
        <div class="presentation-page__column presentation-page__column--text">
          <p class="presentation-page__eyebrow">ÜBER UNS</p>

          <h2 class="presentation-page__headline">
            One life.<br />
            One planet.<br />
            One way.
          </h2>

          <div class="presentation-page__accent-line" aria-hidden="true"></div>

          <p class="presentation-page__body-lead">
            Wir bauen Energielösungen, die in 20 Jahren noch laufen — schlüsselfertig, dokumentiert,
            betrieben.
          </p>
        </div>

        <div class="presentation-page__column presentation-page__column--media">
          <figure class="presentation-page__figure">
            <img
              class="presentation-page__image"
              src="/img/master_presentation/master_presentation_page_02.png"
              alt="eway – ONE LIFE ONE PLANET ONE WAY"
            />
          </figure>
          <p class="presentation-page__image-caption bg-teal">
            Photovoltaik mit industrieller Stärke
          </p>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage02',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },
};
</script>
